import { BASE_IMG_PATH, trayVariants } from "./../../helpers"
import StyledItem from "./StyledItem"
import { Link } from "react-router-dom"

const SideTrayMenu = () => {
  return (
    <div>
      {trayVariants.map(tray => (
        <Link
          style={{ color: "black" }}
          key={tray.variant}
          replace={true}
          to={{
            search: `?trayVariant=${tray.variant}`,
          }}
        >
          <StyledItem>
            <img src={BASE_IMG_PATH.concat(tray.src)} alt={tray.alt} />
            <figcaption>
              <strong>{tray.variant}</strong>
            </figcaption>
          </StyledItem>
        </Link>
      ))}
    </div>
  )
}

export default SideTrayMenu
